import creditCardIcons from '@Builder/QuoteCheckoutPage/components/PaymentOptions/PaymentOptionsList/assets'
import pageStyles from '@User/MyAccountPage/styles.css'
import { FC } from 'react'

import Box from '~/core/Box'
import Image from '~/core/Image'
import Link from '~/core/Link'
import Text from '~/core/Text'
import { PaymentOptionFragment } from '~/gql/graphql'

type PaymentOptionPropsType = {
    payment: PaymentOptionFragment | null
    setRemoveCard: (removeCard: string | null) => void
    selectedField: string | null
}

const PaymentOption: FC<PaymentOptionPropsType> = ({
    payment,
    setRemoveCard,
    selectedField,
}) => {
    const cardType: keyof typeof creditCardIcons = payment?.card?.brand
        ? (payment.card.brand.toLowerCase() as keyof typeof creditCardIcons)
        : 'default'

    const handleRemoveCard = (evt: Event) => {
        evt.preventDefault()
        setRemoveCard(payment?.referenceId || null)
    }

    return (
        <Box flex="1" marginBottom="16px" height="auto">
            <Box flex="1" direction="col">
                <Box alignItems="center">
                    <Image
                        src={
                            creditCardIcons[cardType] ||
                            creditCardIcons['default']
                        }
                        width="32px"
                        height="32px"
                    />
                    <Text fontWeight={500} style={{ marginLeft: '8px' }}>
                        {payment?.card?.brand} (***{payment?.card?.last4})
                    </Text>
                </Box>
            </Box>
            {selectedField !== payment?.id && (
                <>
                    <Box className={pageStyles.tabletHide}>
                        <Link to={null} onClick={handleRemoveCard}>
                            Remove card
                        </Link>
                    </Box>
                    <Box className={pageStyles.tabletShow}>
                        <Link to={null} onClick={handleRemoveCard}>
                            Remove
                        </Link>
                    </Box>
                </>
            )}
        </Box>
    )
}

export default PaymentOption
